var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5303 2.46967C21.8232 2.76256 21.8232 3.23744 21.5303 3.53033L3.53033 21.5303C3.23744 21.8232 2.76256 21.8232 2.46967 21.5303C2.17678 21.2374 2.17678 20.7626 2.46967 20.4697L20.4697 2.46967C20.7626 2.17678 21.2374 2.17678 21.5303 2.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02393 18.158C9.72038 18.4479 10.4682 18.6391 11.25 18.7142V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V18.7142C16.6783 18.337 19.75 15.0272 19.75 11V10C19.75 9.58579 19.4142 9.25 19 9.25C18.5858 9.25 18.25 9.58579 18.25 10V11C18.25 14.4518 15.4518 17.25 12 17.25C11.3729 17.25 10.7673 17.1576 10.1962 16.9858L9.02393 18.158Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2395 15.9425C11.4874 15.9804 11.7414 16 12 16C14.7614 16 17 13.7614 17 11V10.182L11.2395 15.9425Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3263 4.49173L7.54523 13.2728C7.19663 12.5909 7 11.8184 7 11V7C7 4.23858 9.23858 2 12 2C13.8473 2 15.4606 3.00179 16.3263 4.49173Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62567 14.1924L5.53802 15.28C4.72411 14.0536 4.25 12.5822 4.25 11V10C4.25 9.58579 4.58579 9.25 5 9.25C5.41421 9.25 5.75 9.58579 5.75 10V11C5.75 12.1663 6.06947 13.258 6.62567 14.1924Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneSlash);
export default __webpack_public_path__ + "static/media/microphone-slash.b2f6c1fde60f4b747ceed3402c984cda.svg";
export { ForwardRef as ReactComponent };